var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ErrorUtils } from '@popup/steem/utils/error.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { SteemEngineConfigUtils } from '@popup/steem/utils/steemengine-config.utils';
import { KeychainError } from 'src/keychain-error';
const sendOperation = (operations, key, options) => __awaiter(void 0, void 0, void 0, function* () {
    const transactionResult = yield SteemTxUtils.createSignAndBroadcastTransaction(operations, key, options);
    if (transactionResult) {
        if (transactionResult.isUsingMultisig) {
            return {
                tx_id: transactionResult.tx_id,
                broadcasted: false,
                confirmed: false,
                isUsingMultisig: true,
            };
        }
        else {
            return yield SteemEngineUtils.tryConfirmTransaction(transactionResult.tx_id);
        }
    }
    else {
        return {
            broadcasted: false,
            confirmed: false,
            tx_id: '',
        };
    }
});
const tryConfirmTransaction = (trxId) => {
    let result;
    return new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        for (let i = 0; i < 20; i++) {
            let res = yield SteemEngineUtils.getDelayedTransactionInfo(trxId);
            result = res.result;
            if (result !== null)
                break;
        }
        var error = null;
        if (result && result.logs) {
            var logs = JSON.parse(result.logs);
            if (logs.errors && logs.errors.length > 0) {
                error = logs.errors[0];
                reject(ErrorUtils.parseSteemEngine(error, JSON.parse(result.payload)));
            }
        }
        if (result != null) {
            resolve({ broadcasted: true, confirmed: true, tx_id: trxId });
        }
        else {
            resolve({ broadcasted: true, confirmed: false, tx_id: trxId });
        }
    }));
};
/* istanbul ignore next */
const getDelayedTransactionInfo = (trxID) => {
    return new Promise(function (fulfill, reject) {
        setTimeout(function () {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${SteemEngineConfigUtils.getApi()}/blockchain`;
                let resolved = false;
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({
                        id: 1,
                        jsonrpc: '2.0',
                        method: 'getTransactionInfo',
                        params: {
                            txid: trxID,
                        },
                    }),
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((res) => {
                    if (res && res.status === 200) {
                        resolved = true;
                        return res.json();
                    }
                })
                    .then((res) => fulfill(res));
                setTimeout(() => {
                    if (!resolved) {
                        reject(new KeychainError('html_popup_tokens_timeout'));
                    }
                }, 20 * 1000);
            });
        }, 1000);
    });
};
/* istanbul ignore next */
const get = (params, timeout = 10) => __awaiter(void 0, void 0, void 0, function* () {
    // const url = `${HiveEngineConfigUtils.getApi()}/contracts`;
    // return new Promise((resolve, reject) => {
    //   let resolved = false;
    //   fetch(url, {
    //     method: 'POST',
    //     body: JSON.stringify({
    //       jsonrpc: '2.0',
    //       method: 'find',
    //       params,
    //       id: 1,
    //     }),
    //     headers: { 'Content-Type': 'application/json' },
    //   })
    //     .then((res) => {
    //       if (res && res.status === 200) {
    //         resolved = true;
    //         return res.json();
    //       }
    //     })
    //     .then((res: any) => {
    //       resolve(res.result as unknown as T);
    //     });
    //   setTimeout(() => {
    //     if (!resolved) {
    //       reject(new KeychainError('html_popup_tokens_timeout'));
    //     }
    //   }, timeout * 1000);
    // });
    return new Promise((resolve, reject) => {
        resolve([]);
    });
});
/* istanbul ignore next */
const getHistory = (account, symbol, offset = 0, type = 'user', timeout = 10) => __awaiter(void 0, void 0, void 0, function* () {
    const queryParams = `account=${account}&symbol=${symbol}&offset=${offset}&type=${type}`;
    const url = `${SteemEngineConfigUtils.getAccountHistoryApi()}/accountHistory?${queryParams}`;
    return new Promise((resolve, reject) => {
        let resolved = false;
        fetch(url)
            .then((res) => {
            if (res && res.status === 200) {
                resolved = true;
                return res.json();
            }
        })
            .then((res) => {
            resolve(res);
        });
        setTimeout(() => {
            if (!resolved) {
                reject(new KeychainError('html_popup_tokens_timeout'));
            }
        }, timeout * 1000);
    });
});
export const SteemEngineUtils = {
    get,
    getDelayedTransactionInfo,
    getHistory,
    sendOperation,
    tryConfirmTransaction,
};
